import React from "react";
import ReactECharts from "echarts-for-react";
import { border, position } from "@chakra-ui/system";

const HorizontalBarChart = () => {
  const options = {
    title: {
      text: "By Channel",
      left: "left",
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "10%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLabel: false,
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: ["Audio Ads", "Display Ads", "Pop Ads", "Push Notifications"],
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        fontSize: 12,
        fontWeight: "bold",
        align: "right"      
      },
    },
    series: [
      {
        name: "Impressions",
        type: "bar",
        data: [2407, 2407, 2407, 2407],
        barWidth: 15,
        itemStyle: {
          color: "#F95C39",
        },
        label: {
          show: true,
          position: "right",
          formatter: "{c}",
          fontSize: 12,
          fontWeight: "bold",
        },
      },
      {
        name: "Clicks",
        type: "bar",
        data: [764, 764, 764, 764],
        barWidth: 15,
        itemStyle: {
          color: "#FFA500",
        },
        label: {
          show: true,
          position: "right",
          formatter: "{c}",
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    ],
    // legend: {
    //   data: ["Impressions", "Clicks"],
    //   bottom: "bottom",
    // },
  };

  return  <ReactECharts option={options} style={{ height: "400px", width: "100%", background: "#FBFBFD", paddingTop: "20px", paddingLeft: "10px" }} />;
};

export default HorizontalBarChart;
